import React, { useContext, useEffect, useState } from 'react'
import Layout from '../../Component/layout/main-layout'
import layoutBgImg from '../../Images/layout/sale.jpg'
import { GetDocumentSampleTable } from '../../api/Queries/get';
import { useLocation } from 'react-router-dom';
import { Context } from '../../Store/context';
import { useTranslation } from 'react-i18next';
import Loading from '../../Component/loader/loader';
import GlobalLayout from '../../Component/layout/global-layout';

const Document = () => {
    const location = useLocation().pathname.split('/')[2];
    const [document, setDocument] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const { i18n, t } = useTranslation();
    const { showError } = useContext(Context);

    const getLawContent = (laws) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
            return laws.rus_content;
        } else if (currentLang === 'en') {
            return laws.eng_content;
        }
        return laws.tm_content;
    };

    const getLawName = (laws) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
            return laws.rus_name;
        } else if (currentLang === 'en') {
            return laws.eng_name;
        }
        return laws.tm_name;
    };

    useEffect(() => {
        setIsLoading(true)
        const getDocumentSample = async () => {
            try {
                const res = await GetDocumentSampleTable(location)
                setIsLoading(false)
                setDocument(res.data)
            } catch (error) {
                showError(error.message);
                setIsLoading(false)
            }
        }
        getDocumentSample()
    }, [location, showError])

    return (
        <GlobalLayout
            title={`${t('document_sample')} - ${t('supreme_court')} ${t('turkmenistan')}`}
            keywords="Образцы документов, Resminamalaryň nusgalary, Resminama nusgalary"
        >
            <div className='mb-20'>
                <Layout
                    title={t('document_sample')}
                    page={getLawName(document)}
                    layoutBgImg={layoutBgImg}
                />
                <main className='px-4 xxl:px-12 xxxl:px-32 xxxxl:px-64 
                             xxxxxl:px-[400px] xxxxxxl:px-[650px]
                             xxxxxxxl:px-[1600px] xxxxxxxxl:px-[2400px]'>
                    <div className='bg-white mt-8 p-8 w-full
                                dark:bg-dark-box dark:text-dark-text'>
                        {isLoading ? <Loading /> :
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: document ?
                                        getLawContent(document) : ''
                                }}

                            />
                        }
                    </div>
                </main>
            </div>
        </GlobalLayout>
    )
}

export default Document


